import React, { ReactElement, useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/HomePage";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Notification from "./pages/Notification";
import Login from "./components/Login";
import Devices from "./pages/Devices";
import UserAdd from "./pages/UserAdd";
import UserProfile from "./pages/UserProfile";
import DeviceAdd from "./pages/DeviceAdd";
import DeviceProfile from "./pages/DeviceProfile";
import LogListPage from "./pages/LogListPage";
import Logout from "./pages/Logout";
import SteelInventory from "./pages/SteelInventory";
import QrManagement from "./pages/QrManagement";
import AddQrPage from "./pages/AddQrPage";
//import eruda from "eruda";
import Hotjar from "@hotjar/browser";
import Stock from "./pages/Stock";

const siteId = 5295545;
const hotjarVersion = 6;

interface PrivateRouteProps {
  isAuthenticated: boolean;
  children: ReactElement | null;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ isAuthenticated, children }) => {
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(!!localStorage.getItem("isAuthenticated"));
  useEffect(() => {
    //eruda.init();
    Hotjar.init(siteId, hotjarVersion);
  }, []);

  const handleLogin = () => {
    localStorage.setItem("isAuthenticated", "true");
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("isAuthenticated");
    setIsAuthenticated(false);
  };

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login onLogin={handleLogin} />} />
        <Route path="/logout" element={<Logout onLogout={handleLogout} />} />
        <Route
          path="/*"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/users" element={<Users />} />
                <Route path="/notification" element={<Notification />} />
                <Route path="/user/:id" element={<UserProfile />} />
                <Route path="/device/:id" element={<DeviceProfile />} />
                <Route path="/useradd" element={<UserAdd />} />
                <Route path="/deviceadd" element={<DeviceAdd />} />
                <Route path="/devices" element={<Devices />} />
                <Route path="/stock" element={<Stock />} />
                <Route path="/magazyn-stali" element={<SteelInventory />} />
                <Route path="/logs" element={<LogListPage />} />
                <Route path="/qr-management" element={<QrManagement />} />
                <Route path="/add-qr" element={<AddQrPage />} />
              </Routes>
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
